// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"202":"7a3bb543a48175c3f124","678":"42a6c6c4f8d69446ab32","883":"37add549bc4325d099d8"}[chunkId] + ".js";
};